import type React from 'react';

import MenuIcon from './components/MenuIcon';
import MenuItem from './components/MenuItem';
import MenuLabel from './components/MenuLabel';

import cn from '../../utils/cn';

export interface MenuProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const Menu = ({ children, className }: MenuProps) => {
  return <div className={cn('flex flex-col px-2 py-2.5', className)}>{children}</div>;
};

Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Icon = MenuIcon;

export default Menu;
